import React from 'react';
import { Flex, Text, Image, Button, CloseButton, Box, Portal, Dialog } from '@chakra-ui/react';
import MultiRef from 'react-multi-ref';
import moment from 'moment';
import theme from '../theme';

const FullViewImage = ({ src, close, nav, navDrawerEnabled, navDrawerOpen }) => (
	<>
		<Box
			position="absolute"
			top={0}
			left={nav && (!navDrawerEnabled || navDrawerOpen) ? '630px' : 0}
			width={nav && (!navDrawerEnabled || navDrawerOpen) ? 'calc(100% - 630px)' : '100%'}
			height="100%"
			zIndex={5}
			bg="rgba(50, 50, 50, 0.75)"
			onClick={close}
			transition="400ms"
			transitionTimingFunction="ease-in-out"
		>
			<Box
				position="relative"
				w="calc(100% - 100px)"
				h="calc(100% - 100px)"
				left="50px"
				top="50px"
				zIndex={10}
				bgColor={theme.colors.white}
				onClick={close}
			>
				<Image objectFit="contain" h="100%" mx="auto" src={src} />
			</Box>
		</Box>
	</>
);

const AttachmentsList = ({
	attachments,
	readOnly,
	attachmentType,
	nav,
	navDrawerEnabled,
	navDrawerOpen,
	removeAttachment
}) => {
	const [fullImage, setFullImage] = React.useState('');
	const [removeAttachmentDialogOpen, setRemoveAttachmentDialogOpen] = React.useState(null);
	const [cancelRefs] = React.useState(() => new MultiRef());

	return (
		<Flex flexWrap="wrap" alignItems="flex-start">
			{fullImage && (
				<Portal top="82px" h="calc(100% - 82px)">
					<FullViewImage
						src={fullImage}
						nav={nav}
						close={() => setFullImage('')}
						navDrawerEnabled={navDrawerEnabled}
						navDrawerOpen={navDrawerOpen}
					/>
				</Portal>
			)}
			{attachments.map(({ id, image, comment, attachment_comment, creator, created, formId, formTitle }) => (
				<Flex key={id} direction="column" align="flex-start" padding="16px" w={(1 / 3) * 100 + '%'}>
					{!readOnly && (
						<CloseButton
							size="md"
							my="8px"
							mr="8px"
							color={theme.colors.white}
							bgColor={theme.colors.red[500]}
							_hover={{ background: theme.colors.red[600] }}
							onClick={() => setRemoveAttachmentDialogOpen(id)}
						/>
					)}
					<Image flex={1} w="auto" maxH="300px" mb="8px" src={image} onClick={() => setFullImage(image)} />
					<Flex direction="column" alignItems="flex-start">
						<Text fontWeight="bold" whiteSpace="pre-wrap">
							{comment || attachment_comment}
						</Text>
						<Text>
							{creator ? `${creator} - ` : null}
							{`${moment(new Date(created)).format('YYYY/MM/DD')}`}
						</Text>
						<Text textTransform="capitalize">{formTitle || formId?.split('_')?.join(' ') || ''}</Text>
					</Flex>
					<Dialog.Root
						role="alertdialog"
						initialFocusEl={cancelRefs.map.get(id)}
						onOpenChange={({ open }) => {
							if (!open) {
								setRemoveAttachmentDialogOpen(null);
							}
						}}
						open={removeAttachmentDialogOpen === id}
						placement="center"
					>
						<Portal>
							<Dialog.Backdrop />
							<Dialog.Positioner>
								<Dialog.Content opacity="1 !important">
									<Dialog.Header>
										<Dialog.Title fontSize="lg" fontWeight="bold">
											Confirm Delete
										</Dialog.Title>
									</Dialog.Header>
									<Dialog.Body>
										<p>Are you sure you want to remove this item?</p>
									</Dialog.Body>
									<Dialog.Footer>
										<Dialog.ActionTrigger asChild>
											<Button
												ref={cancelRefs.ref(id)}
												onClick={() => setRemoveAttachmentDialogOpen(null)}
											>
												Cancel
											</Button>
										</Dialog.ActionTrigger>
										<Button
											colorPalette="red"
											ml={3}
											bg={theme.colors.red[500]}
											_hover={{ background: theme.colors.red[600] }}
											color={theme.colors.white}
											onClick={() => {
												removeAttachment(id, attachmentType);
												setRemoveAttachmentDialogOpen(null);
											}}
										>
											Delete Item
										</Button>
									</Dialog.Footer>
									<Dialog.CloseTrigger asChild>
										<CloseButton size="sm" />
									</Dialog.CloseTrigger>
								</Dialog.Content>
							</Dialog.Positioner>
						</Portal>
					</Dialog.Root>
				</Flex>
			))}
		</Flex>
	);
};

export default AttachmentsList;
